<template>
  <template v-for="(row, index) in rowList" :key="index">
    <RowDataTableComponent
      :row="row"
      :columns="columns"
      :actions="actions"
      @emitRowAction="emitRowAction"
      @clickAction="clickAction"
    />
  </template>
</template>

<script>
import RowDataTableComponent from "@/components/data-table/RowDataTableComponent.vue";

export default {
  name: "BodyDataTableComponent",
  components: { RowDataTableComponent },
  props: {
    rowList: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ["emitRowAction", "clickAction"],
  methods: {
    emitRowAction(payload) {
      this.$emit("emitRowAction", payload);
    },

    clickAction(payload) {
      this.$emit("clickAction", payload);
    },
  },
};
</script>

<style lang="scss" scoped></style>
